import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'highlight',
    standalone: true
})
export class HighlightPipe implements PipeTransform {

  static escapeHtml(unsafe): string {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  transform(value: string, searchText: string): string {
    value = HighlightPipe.escapeHtml(value);
    if (!searchText) {
      return value;
    }

    return value.replace(new RegExp(searchText, 'gi'), match => {
      return '<span class="highlight-search">' + match + '</span>';
    });
  }
}
